import { PublicClientApplication } from "@azure/msal-browser";
import { getMsalConfig } from "./msalAuthConfig";

export const IS_ACTIVE_IMPERSONATION = 'isActiveImpersonation';

export let isImpersonating = localStorage.getItem(IS_ACTIVE_IMPERSONATION);

export const setIsImpersonating = (v) => {
    isImpersonating = v
}

let initPromise = null;
let impersonationInitPromise = null;

export const getOrInitMsalInstance = async (brandslug, impersonation) => {
    const config = getMsalConfig(brandslug, impersonation)
    if(config && ((!impersonation && !initPromise) || (impersonation && !impersonationInitPromise))) {
        const msalInstance = new PublicClientApplication(config)
        const promise = msalInstance.initialize().then(() => {
            return msalInstance;
        });

        if(impersonation) {
            impersonationInitPromise = promise
        } else {
            initPromise = promise
        }
    }

    return impersonation ? impersonationInitPromise : initPromise
}